<template>
  <div>
    <div class="registrationSurface">
      <div class="table_conent">
        <div class="search_box">
          <div class="search_box_left">
            <div class="block">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              @change="onPick"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </div>

              
          <div>
            <el-input
              v-model="params.search_name"
              placeholder="请输入订单号账号昵称渠道名字"
              class="el_input_style"
            >
            </el-input
            >  
          </div>
           

          <div>
            <el-button
              type="goon"
              style="margin-left:20px"
              icon="el-icon-search"
              @click="onPickSearch_name()"
            ></el-button>
          </div>
          </div>
          
          <div class="totalAmount">
            当前包月充值金额 ：<span>{{ samount }}元</span>
          </div>
        </div>

        <template>
          <div class="table_title">包月订单</div>
          <el-table
            class="tableBox"
            style="height: 100%"
            :header-cell-style="{
              background: '#F1F6F9',
              color: '#606266',
              width: '100%',
            }"
            :data="tableData"
            border
          >
            <el-table-column label="订单号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.order_sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="账号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.agent_account }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="dataTime" label="昵称" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="渠道名字" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.agentname }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="月数" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.month }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="台数" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.count }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="dataTime" label="充值金额" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="充值时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.pay_at }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      value1: [dayjs().add(-7, "days").format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],
      tableData: [], // 列表数据
      total: null,
      params: {
        end_at: "",
        page: 1,
        search_name: "",
        start_at: "",
        type: "cyber",
      },
      samount: "0.00",
    };
  },
  created() {
    this.initChannelList();
  },
  methods: {
    initChannelList() {
      this.$http.post(this.$api.api.bar_order_list, this.params).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.total = res.data.count;
        this.tableData = res.data.result;
        this.samount = res.data.samount != "" ? res.data.samount : "0.00";
      });
    },
    onPickSearch_name() {
      this.initChannelList();
    },
    // 搜索
    // 选择日期
    onPick(val) {
      this.params.start_at = val[0];
      this.params.end_at = val[1];
      this.initChannelList();
    },

    // 分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.initChannelList();
    },
  },
};
</script>

<style scoped lang="scss">
.search_box {
 
  height: 50px;
  .search_box_left {
    float: left;
    display: flex;
    margin-right: 20px;
    div{
      margin-left: 20px;
    }
  }
  .totalAmount{
    float: right;
  }
}
.el-pagination {
  text-align: right;
}
.registrationSurface {
  // padding: 10px;
  overflow: auto;
  .table_conent {
    padding-top: 10px;
    .table_title {
      border: 1px solid #ebeef5;
      border-bottom: 0px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #f1f6f9;
    }
    .table_btn {
      width: 80px !important;
    }
  }
}
.totalAmount {
  font-size: 16px;
  line-height: 40px;
  span {
    color: red;
    font-weight: bold
  }
}
</style>